import { render, staticRenderFns } from "./InformationCertification.vue?vue&type=template&id=551eb80a&scoped=true"
import script from "./InformationCertification.vue?vue&type=script&lang=js"
export * from "./InformationCertification.vue?vue&type=script&lang=js"
import style0 from "./InformationCertification.vue?vue&type=style&index=0&id=551eb80a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551eb80a",
  null
  
)

export default component.exports